/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Aircraft(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0003 1.74999C10.2692 1.75015 10.5182 1.89439 10.6516 2.12792L13.7688 7.583H16.6673C17.308 7.58312 17.9231 7.8379 18.3762 8.29101C18.8293 8.7442 19.0843 9.35916 19.0843 9.99999C19.0843 10.6408 18.8293 11.2558 18.3762 11.709C17.9231 12.1621 17.308 12.4169 16.6673 12.417H13.7688L10.6516 17.8721C10.5182 18.1056 10.2692 18.2498 10.0003 18.25H7.50027C7.26514 18.2499 7.0433 18.1388 6.90164 17.9512C6.76015 17.7633 6.71496 17.5201 6.77957 17.2939L8.17312 12.417H6.1448L4.69754 13.8633C4.55699 14.0038 4.36601 14.0829 4.16726 14.083H1.66726C1.40743 14.083 1.16625 13.9485 1.02957 13.7275C0.892937 13.5065 0.880188 13.2305 0.996364 12.998L2.49539 9.99999L0.996364 7.00194C0.880188 6.76948 0.892937 6.49352 1.02957 6.27245C1.16625 6.0515 1.40743 5.91698 1.66726 5.91698H4.16726L4.31472 5.93163C4.45852 5.96057 4.59228 6.03145 4.69754 6.13671L6.1448 7.583H8.17312L6.77957 2.70605C6.71496 2.47992 6.76015 2.23665 6.90164 2.04882C7.0433 1.86115 7.26514 1.75009 7.50027 1.74999H10.0003ZM9.88797 8.12694C9.95255 8.35311 9.90747 8.59732 9.76589 8.78515C9.62426 8.97281 9.40237 9.08286 9.16726 9.083H5.83425C5.63545 9.083 5.44461 9.00379 5.30398 8.86327L3.85672 7.41698H2.88113L4.00515 9.66503C4.11026 9.87579 4.11026 10.1242 4.00515 10.335L2.88113 12.583H3.85672L5.30398 11.1367L5.41824 11.043C5.54046 10.9616 5.68526 10.917 5.83425 10.917H9.16726C9.40237 10.9171 9.62426 11.0272 9.76589 11.2148C9.90747 11.4027 9.95255 11.6469 9.88797 11.873L8.49539 16.75H9.5657L12.6829 11.2949L12.7376 11.2109C12.8783 11.0269 13.0988 10.917 13.3343 10.917H16.6673C16.9102 10.9169 17.1439 10.8202 17.3157 10.6484C17.4875 10.4765 17.5843 10.243 17.5843 9.99999C17.5843 9.75698 17.4875 9.52344 17.3157 9.35155C17.1439 9.17975 16.9102 9.08312 16.6673 9.083H13.3343C13.0652 9.083 12.8164 8.93864 12.6829 8.70507L9.5657 3.24999H8.49539L9.88797 8.12694Z"
        fill="#35424F"
      />
    </svg>
  )
}

Aircraft.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Aircraft
